const handleOrderBy = function (orderBy) {
  let order = "sortDisabled";

  if (orderBy === "date") {
    order = "date:asc,date:asc";
  } else if (orderBy === "dateReverse") {
    order = "date:desc,date:desc";
  } else if (orderBy === "severity") {
    order = "severity:asc";
  } else if (orderBy === "severityReverse") {
    order = "severity:desc";
  } else if (orderBy === "status") {
    order = "status:asc";
  } else if (orderBy === "statusReverse") {
    order = "status:desc";
  }

  return order;
};

export { handleOrderBy };
